module.exports = __webpack_public_path__ + "img/26.647b6bf7.jpg";